/** The same short attachment labels the conversation API uses for its list. */
export const sidebarPreview = (message, myId, myName) => {
    const files = message.outgoing?.files || message.attachments || [];
    const first = files[0];
    const type = message.outgoing?.audioMeta ? 'audio'
        : first?.type?.startsWith?.('image/') ? 'image'
        : first?.type?.startsWith?.('audio/') ? 'audio'
        : first?.type?.startsWith?.('video/') ? 'video'
        : first?.type || 'document';
    const labels = { image: '📷 Photo', audio: '🎤 Voice note', video: '🎬 Recording', document: '📎 File' };
    const text = message.text
        ? message.text.slice(0, 140)
        : first ? `${labels[type] || labels.document}${files.length > 1 ? ` +${files.length - 1}` : ''}` : '';
    return { text, kind: first ? type : 'text', sender: myId, senderName: myName, at: message.createdAt };
};

/** A late list fetch or POST reply must not push a newer conversation backwards. */
export const bumpConversation = (rows, id, preview) => {
    const index = rows.findIndex(row => String(row._id) === String(id));
    if (index === -1) return rows;
    const row = rows[index];
    if (row.lastActivityAt && new Date(row.lastActivityAt) > new Date(preview.at)) return rows;
    const next = [...rows];
    next.splice(index, 1);
    next.unshift({ ...row, lastMessage: preview, lastActivityAt: preview.at });
    return next;
};

/** Local uploads overlay the server list, while confirmed messages use its normal rows. */
export const sidebarRows = (rows, outbox, myId, myName) => rows.map(row => {
    const unsent = (outbox[String(row._id)] || []).filter(message => message.local);
    const local = unsent[unsent.length - 1];
    if (!local) return row;
    return {
        ...row,
        lastMessage: {
            ...sidebarPreview(local, myId, myName),
            deliveryStatus: local.failed ? 'failed' : 'sending',
            uploadProgress: local.uploadProgress,
            uploadState: local.uploadState
        },
        lastActivityAt: local.createdAt
    };
}).sort((a, b) => new Date(b.lastActivityAt || 0) - new Date(a.lastActivityAt || 0));
